import * as types from 'constants/ActionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {boolean} */
const initialState = false;

const isLoading = () => true;

const isEnding = () => false;

export default createReducer(initialState, {
  [types.FETCH_STATISTICS_REVENUE_BY_PERIOD_STATS_REQUEST]: isLoading,
  [types.FETCH_STATISTICS_REVENUE_BY_PERIOD_STATS_FAILURE]: isEnding,
  [types.FETCH_STATISTICS_REVENUE_BY_PERIOD_STATS_SUCCESS]: isEnding,
});
